import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import operationAddressReducer from './operationAddressesReducer'
import { operationTypes } from 'actions/types'

const initialState = null
const baseType = operationTypes.FETCH_OPERATION

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
  addresses: operationAddressReducer,
})

export default reducer
